import { render, staticRenderFns } from "./UnlinkRequests.vue?vue&type=template&id=ef388d82&"
import script from "./UnlinkRequests.vue?vue&type=script&lang=js&"
export * from "./UnlinkRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports